import { NgModule, ModuleWithProviders } from '@angular/core';
import { HttpModule, XHRBackend, RequestOptions } from '@angular/http';
import {
  StoreModule,
  _storeFactory,
  Dispatcher,
  Reducer,
  State,
} from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { AuthModule, Auth, AUTH_CONFIG, AuthConfig } from '@shared/auth';

import { Datastore } from './datastore';
import { ApiHttp } from './api-http.service';
import { WebSocketService } from './websocket';
import { store, Store } from './store';
import { DATASTORE_CONFIG } from './datastore.config';
import { DatastoreConfig } from './datastore.interface';

@NgModule({
  imports: [
    HttpModule,
    AuthModule,
    StoreModule.provideStore(store),
    StoreDevtoolsModule.instrumentOnlyWithExtension({
      maxAge: 5,
    }),
  ],
  providers: [
    ApiHttp,
    WebSocketService,
    {
      provide: Store,
      useFactory: _storeFactory,
      deps: [Dispatcher, Reducer, State],
    },
  ],
})
export class DatastoreModule {
  static initialize(config: DatastoreConfig): ModuleWithProviders {
    return {
      ngModule: DatastoreModule,
      providers: [Datastore, { provide: DATASTORE_CONFIG, useValue: config }],
    };
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build/webapp/src/app/@shared/datastore/datastore.module.ts